exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".Discussion-ModalButton-Root {\n  display: inline-block;\n  margin: 0 10px;\n  box-sizing: border-box;\n  padding: 10px 20px;\n  border-radius: 3px;\n  cursor: pointer;\n  background-color: #999fa1;\n  color: #fff;\n  font-size: 12px;\n  font-weight: bold;\n  line-height: 20px;\n  text-align: center;\n  text-transform: uppercase;\n  user-select: none;\n}\n.Discussion-ModalButton-Root[data-color=\"primary\"] {\n  background-color: #2c75e7;\n}\n.Discussion-ModalButton-Root[data-color=\"danger\"] {\n  background-color: #fe4540;\n}\n", ""]);

// exports
